import _ from 'lodash';
import store from 'core/store';
import createHttp from 'utils/http';
import c from 'common/constants/flux-events';
import $ from 'jquery';
import { flatMap } from 'utils/enum';
const http = createHttp;

const API = {};

export default API;
